<section class="organization-offer-banner" *ngIf="organization">
  <div class="banner-pill banner-pill--lead">
    <span class="live-dot" aria-hidden="true"></span>
    <!-- <span class="banner-kicker">Contexte offre</span> -->
  </div>
  <!-- <span class="banner-divider" aria-hidden="true"></span> -->
  <div class="banner-pill">
    <!-- <span class="metric-dot metric-dot--offer" aria-hidden="true"></span> -->
    <span>offre actuelle</span>
    <strong>{{ currentOfferLabel }}</strong>
  </div>
  <span class="banner-divider" aria-hidden="true"></span>
  <div class="banner-pill">
    <span class="metric-dot metric-dot--renewal" aria-hidden="true"></span>
    <span>renouvellement</span>
    <strong>{{ nextRenewalLabel }}</strong>
  </div>
  <span class="banner-divider" aria-hidden="true"></span>
  <div class="banner-pill">
    <span class="metric-dot metric-dot--seats" aria-hidden="true"></span>
    <span>nombre de collaborateurs</span>
    <strong>{{ seatCountLabel }}</strong>
  </div>
  <span class="banner-divider" aria-hidden="true"></span>
  <div class="banner-pill">
    <span class="metric-dot metric-dot--journeys" aria-hidden="true"></span>
    <!-- <span>parcours restants</span> -->
    <strong>{{ journeysRemainingLabel }}</strong>
    <span>parcours restants</span>
  </div>
</section>
